import Logo from './Logo';

export default Logo;



// WEBPACK FOOTER //
// ./src/shared/components/Logo/index.ts